export function joinObjects(...values) {
    var result = {};

    for (const value of values) {
        if (value instanceof Object) {
            result = { ...result, ...value };
        }
    }

    return result;
}

export function pipe(obj, fn) {
    return fn(obj);
}

export function pipeWhenTrue(obj, fn) {
    if (obj)
        return fn(obj);
    return null;
}

export function cond(...conditions) {
    for (const [condition, result] of conditions) {
        if (condition) {
            if (typeof result === 'function') {
                return result();
            } else {
                return result;
            }
        }
    }
}

export function truncateArray(arr, maxLength) {
    if (arr.length <= maxLength) {
        return arr;
    }

    const numNumericElements = maxLength - 1;
    const leftCount = Math.ceil(numNumericElements / 2);
    const rightCount = Math.floor(numNumericElements / 2);

    const startElements = arr.slice(0, leftCount);
    const endElements = arr.slice(arr.length - rightCount);

    return [...startElements, '...', ...endElements];
}

export function valueFrom(x) {
    return document.getElementById(x)?.value;
}

export function find(x) {
    return document.getElementById(x);
}

export function roundDecimals(value, decimals) {
    return Math.round(value * Math.pow(10, decimals)) / Math.pow(10, decimals);
}

export function ellipsis(text, maxLength = 30) {
    if (!text?.length || text.length <= maxLength) {
        return text;
    }

    const ellipsisChars = "...";
    const charsToShow = maxLength - ellipsisChars.length;
    const frontChars = Math.ceil(charsToShow / 2);
    const backChars = Math.floor(charsToShow / 2);

    return text.slice(0, frontChars) + ellipsisChars + text.slice(text.length - backChars);
}


export function randomId() {
    return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
}

export function normalizeWhitespace(codeString) {
    const normalizeBlock = (block) => {
        if (block.trim() === '') {
            return null;
        }

        const lines = block.split('\n');
        const minIndent = lines.reduce((min, line) => {
            if (line.trim().length === 0) return min;
            const currentIndent = line.match(/^\s*/)[0].length;
            return Math.min(min, currentIndent);
        }, Infinity);

        return lines.map(line => line.substring(minIndent)).join('\n');
    };

    const trimmedInput = codeString.trim();
    const blocks = trimmedInput.split(/\n\s*\n/);
    const normalizedBlocks = blocks
        .map(block => normalizeBlock(block))
        .filter(block => block !== null);

    return normalizedBlocks.join('\n\n');
}

export function indentWhiteSpace(codeString, spaceCount, skipFirstLine = false) {
    const spaceStr = ' '.repeat(spaceCount);
    return codeString.split('\n').map((l, i) => skipFirstLine && i == 0 ? l : spaceStr + l).join("\n");
}


export function repeatNode(times, item) {
    var result = [];
    for (var i = 0; i < times; i++) {
        result.push(item.cloneNode(true));
    }
    return result;
}

export function readBlob(blob) {
    return new Promise((resolve, _) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.readAsDataURL(blob);
    });
}

export function baseHeight(element) {
    return element.offsetHeight - element.offsetTop;
}

export function pageQuery() {
    return {
        query: Object.fromEntries([...new URLSearchParams(window.location.search).entries()]),
        segments: window.location.pathname.split("/").filter(x => x)
    }
}

export function identifierName(name) {
    return name.toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9\-]/g, '');
}